// extracted by mini-css-extract-plugin
export var container = "_bs-0";